import { createAsyncThunk } from '@reduxjs/toolkit';
import { actionTypes } from 'src/redesign/pages/Login/store/constants';
import {
  loginApi,
  sendLoginInit,
  sendPinCodeApi,
  verifyPinCodeApi,
} from 'src/redesign/pages/Login/store/api';
import { Attendee } from 'src/types/types';

export const initialLoginSession = createAsyncThunk(
  actionTypes.INIT_LOGIN,
  async ({ email, recaptchaToken }: { email: Attendee['email']; recaptchaToken?: string }) =>
    await sendLoginInit(email, recaptchaToken),
);

export const loginAction = createAsyncThunk(
  actionTypes.LOGIN,
  async ({
    email,
    password,
    isAttendeeLogin,
    recaptchaToken,
  }: {
    email: Attendee['email'];
    password: string;
    isAttendeeLogin: boolean;
    recaptchaToken?: string;
  }) => await loginApi(email, password, isAttendeeLogin, recaptchaToken),
);

export const sendPinCode = createAsyncThunk(
  actionTypes.SEND_PIN_CODE,
  async ({
    site,
    email,
    recaptchaToken,
  }: {
    site: unknown;
    email: Attendee['email'];
    recaptchaToken?: string;
  }) => await sendPinCodeApi(site, email, recaptchaToken),
);

export const verifyPinCode = createAsyncThunk(
  actionTypes.VERIFY_PIN_CODE,
  async ({
    email,
    codeId,
    inputCode,
    captchaToken,
    site,
    attendeeLogin,
  }: {
    site: unknown;
    email: Attendee['email'];
    captchaToken: string;
    inputCode: string;
    codeId: string;
    attendeeLogin: boolean;
  }) => await verifyPinCodeApi(site, email, captchaToken, inputCode, codeId, attendeeLogin),
);
